import React, { useEffect, useState } from "react";
import { X, FileText } from "lucide-react";

export default function CustomerInvoiceImageModal({ open, onClose, customer }) {
  const [preview, setPreview] = useState("");

  useEffect(() => {
    if (open && customer) {
      setPreview(customer?.image_url || "");
    }
  }, [open, customer]);

  if (!open) return null;

  return (
    <>
   
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1"
      onClick={onClose}
    >
      <div
        className="bg-white w-[95%] max-w-3xl rounded-xl montserrat-font-1 shadow-lg flex flex-col max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="font-semibold text-lg flex items-center gap-2">
            <FileText size={18} />
            Invoice Preview
          </h3>

          <button onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        {/* BODY */}
        <div className="p-4 flex justify-center items-center overflow-y-auto">
          {preview ? (
            <img
              src={preview}
              alt="Invoice"
              className="max-h-[80vh] object-contain rounded shadow"
            />
          ) : (
            <p className="text-gray-400 text-sm">No preview available</p>
          )}
        </div>

        {/* FOOTER */}
        <div className="p-4 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded"
          >
            Close
          </button>
        </div>
      </div>
    </div>
    </>
  );
}
